import { BareActionContext } from 'vuex-typex'
import { RootState } from '@/store'
import mainStore from '@/store/main/main-store';
import { MainState } from '@/store/main/state';

export default async function setCurrentPage(context: BareActionContext<MainState, RootState>, payload: {component: string, page: string, isAuthRequired: boolean, forceLogin: boolean, id?: string|null, uid?: string|null})
{
  mainStore.commitSetCurrentPage(payload)

  return
}
